import { lazy } from "react"
import { isProduction } from "@utils"

export const CheckListRoutes = [
  // {
  //   path: "/checklist/templates/import",
  //   component: lazy(() => import("../views/templates-list")),
  //   layout: "VerticalLayout",
  //   meta: {
  //     action: "call",
  //     resource: "CKL_MANAGE_TEMPLATES"
  //   }
  // },
  {
    path: "/checklist/templates",
    component: lazy(() => import("../views/templates-list")),
    layout: "VerticalLayout",
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/global-items",
    component: lazy(() => import("../views/global-items-list")),
    layout: "VerticalLayout",
    omit: isProduction(),
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/template/:templateId/edit",
    component: lazy(() => import("../views/template-builder")),
    layout: "BlankLayout",
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/global-item/:templateId/edit",
    component: lazy(() => import("../views/template-builder/index.temp")),
    layout: "BlankLayout",
    omit: isProduction(),
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/template/:templateId/trans",
    component: lazy(() => import("../views/template-translate")),
    layout: "BlankLayout",
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/global-response/list",
    component: lazy(() => import("../views/global-yes-no-list")),
    layout: "VerticalLayout",
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  },
  {
    path: "/checklist/library/public",
    component: lazy(() => import("../views/public-libraries-list")),
    className: 'ecommerce-application',
    layout: "BlankLayout",
    omit: isProduction(),
    meta: {
      publicRoute: true,
      general: true
    }
  },
  {
    path: "/checklist/library",
    component: lazy(() => import("../views/public-libraries-list")),
    className: 'ecommerce-application',
    layout: "VerticalLayout",
    // omit: isProduction(),
    meta: {
      action: "call",
      resource: "CKL_MANAGE_TEMPLATES"
    }
  }
]
